import styled from '@emotion/styled';
import { font, mediaQueries, palette, remCalc } from '../../css';
import SwitchWithLabelBuf from '../../UI/Switch/SwitchWithLabel';

export const SwitchWithLabel = styled(SwitchWithLabelBuf)({
    paddingTop: remCalc(10),
    [mediaQueries.large]: {
        paddingBottom: remCalc(15),
        paddingTop: 0,
    },
});

export const SuggestionHeaderContainer = styled('div')(({ theme }) => ({
    color: palette(theme === 'presse' ? 'black' : 'white'),
    display: 'flex',
    flexDirection: 'column',
}));

const StyledProgramSuggestion = styled('div')(() => ({
    [mediaQueries.large]: {
        backgroundColor: 'transparent',
        padding: 0,
    },
    backgroundColor: palette('primary', 'mainNav'),
    padding: remCalc(10, 20),
}));

const StyledProgramSuggestionTitle = styled('h1')(({ theme }) => ({
    [mediaQueries.large]: {
        margin: remCalc(0),
        marginBottom: remCalc(15),
        padding: remCalc(0),
    },
    color: palette(theme === 'presse' ? 'black' : 'white'),
    fontSize: font.size.m,
    fontWeight: font.weight.bold,
    lineHeight: font.size.m,
}));

export const StyledProgramSuggestionHeader = styled('div')(({ theme }) => ({
    [mediaQueries.large]: {
        flexDirection: 'row',
        padding: 0,
    },
    padding: remCalc(5, 0),
    alignItems: 'baseline',
    color: palette(theme === 'presse' ? 'black' : 'white'),
    display: 'flex',
    justifyContent: 'space-between',
    textAlign: 'left',
}));

// const StyledProgramSuggestionHeaderDesktop = StyledProgramSuggestionHeaderMobile.withComponent('div');

const StyledProgramSuggestionWrapper = styled('div')(() => ({
    display: 'block',

    [mediaQueries.large]: {
        border: 'none',
        padding: 0,
        '& > *': {
            marginBottom: remCalc(25),
        },
    },
}));

export { StyledProgramSuggestion, StyledProgramSuggestionTitle, StyledProgramSuggestionWrapper };
